/* eslint-disable @typescript-eslint/no-unused-vars */
import { isEmpty } from 'lodash'
import { Hidden, Paper, TablePagination, Box, Grid } from '@mui/material'

import {
  LoadingFeedback,
  NoData,
  PageHead,
  StandardPageStructure,
  FilterButton,
  StatsCard,
} from 'components'
import { ConsentTable, ConsentFilter } from './components'

import { useFetch, usePagination, useFilter } from 'hooks'
import { consentStatsHelper } from 'helpers'

import { ConsentStatsType } from 'types/consentStats.types'

import service from 'service'

const ConsentMain = () => {
  const filter = useFilter()
  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination()

  const { response, loading } = useFetch(
    service.dpoeasy.consent.get,
    {
      params: {
        page,
        perPage,
        ...filter.filters,
      },
    },
    [page, perPage, filter.filters]
  )

  const { response: statsResponse } = useFetch(
    service.dpoeasy.consent.stats,
    {},
    []
  )

  const consents = response?.data?.consents
  const stats = statsResponse?.data as ConsentStatsType

  const statsCards = consentStatsHelper.getConsentStatsCards(stats)

  return (
    <StandardPageStructure>
      <LoadingFeedback open={loading} />
      <PageHead
        name="Consentimentos registrados (Logs)"
        actionButton={<FilterButton setDrawerOpen={filter.setDrawerOpen} />}
      />

      <Box mb={4}>
        <Grid container spacing={3}>
          {statsCards.map((card, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <StatsCard
                icon={card.icon}
                label={card.label}
                value={card.value}
                backgroundColor={card.backgroundColor}
              />
            </Grid>
          ))}
        </Grid>
      </Box>

      {isEmpty(consents) ? (
        <NoData title="Nenhum registro de consentimento foi encontrado" />
      ) : (
        <Paper variant="outlined">
          <ConsentTable consents={consents} />
          <TablePagination
            component="div"
            count={response?.data?.meta?.totalCount || 0}
            onPageChange={(_, page) => handleChangePage(page)}
            onRowsPerPageChange={handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={perPage}
            rowsPerPageOptions={[5, 10, 25, 100]}
            labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
            slotProps={{
              actions: {
                previousButton: { size: 'small' },
                nextButton: { size: 'small' },
              },
            }}
          />
        </Paper>
      )}
      <ConsentFilter filter={filter} />
    </StandardPageStructure>
  )
}

export default ConsentMain
